module.exports = __webpack_public_path__ + "img/zoom_node_explanation.045c7eb8.png";